import React from "react";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import TitleSection from "src/components/TitleSection/TitleSection";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import TBCBPageWrapper from "src/components/Promotions/TBCB/TBCBPageWrapper";
import TBCBPrizeTablesSection from "src/components/Promotions/TBCB/TBCBPrizeTablesSection";
import TBCBHowItWorksSection from "src/components/Promotions/TBCB/TBCBHowItWorksSection";

const TripleBarrelCashBlast2025 = () => {
  const { t } = useTranslation();

  return (
    <TBCBPageWrapper>
      <EventFinished
        scheduleKeyName="tripleBarrelCashBlast2025"
        eventType="promotion"
      />
      <Hero
        image={t("tripleBarrelCashBlast2025.hero.image")}
        bgImage={t("tripleBarrelCashBlast2025.hero.bgImage")}
        imageAlt={t("tripleBarrelCashBlast2025.hero.imageAlt")}
        fluidImage={"hero?.image" ? false : true}
      />
      <container-div>
        <TitleSection
          as={"h2"}
          title={t("tripleBarrelCashBlast2025.content.title")}
          text={t("tripleBarrelCashBlast2025.content.subtitle")}
          borderColor="#d59947"
          className="mt-4 pb-2"
        />
        <ReactMarkdown>
          {t("tripleBarrelCashBlast2025.content.text")}
        </ReactMarkdown>
        <TBCBPrizeTablesSection
          translationKeyPrefix="tripleBarrelCashBlast2025"
          imagePath="2025"
          layout="bootstrap"
        />
      </container-div>
      <TBCBHowItWorksSection translationKeyPrefix="tripleBarrelCashBlast2025" />
    </TBCBPageWrapper>
  );
};

export default TripleBarrelCashBlast2025;
